export const selectLanguages = state => state.i18n.languages;

export const selectLanguage = state => {
  const {
    language,
    languages
  } = state.i18n;

  return languages.find(({ value }) => value === language);
};

export const selectLocale = state => state.i18n.language;



// WEBPACK FOOTER //
// ./src/selectors/i18.js